import script from "./PostMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PostMenu.vue?vue&type=script&setup=true&lang=js"

import "./PostMenu.vue?vue&type=style&index=0&id=2ebe94ba&lang=scss"

const __exports__ = script;

export default __exports__